export default {
  shiftSchedule: {
    form: {
      longTermPlacements: {
        longTerm: 'Long Term',
        info: 'This job will attract consistent workers who are interested in longer term work.'
      },
      receiveSameTypeOfWorkers: {
        label: 'Receive same type of workers',
        info: 'Use Wonoloers historically matched to these job requirements'
      },
      shift: {
        startDate: 'Start Date',
        endDate: 'End Date',
        label: 'Shift Schedule',
        placeholder: 'Select shift schedule',
        helperText: {
          cannotFindSchedule: "Can't find your schedule? ",
          createSchedule: 'Create a Shift Schedule ',
          verifyLocation: 'or verify the current location.',
        },
        totalJobRequests: 'Total Jobs: %numberOfJobRequests%',
      },
      errors: {
        missingShift: 'Please select a shift',
        missingStartDate: 'Please enter a start date',
        missingEndDate: 'Please enter an end date',
        startDateAfterEndDate: 'Start Date cannot be after End Date'
      }
    },
    recurrenceTable: {
      date: 'Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      unpaidTime: 'Unpaid Time'
    },
    venueConfirmation: {
      edit: {
        title: 'Confirm Location Change',
        content: 'Changing the location will undo all the settings in the subsequent Time section below. This can not be undone.',
        confirm: 'Yes, Change Venue'
      }
    },
    cannotChangeVenue: {
      messageLineOne: 'Once a job is posted using a schedule, the location and schedule can not be changed. ',
      messageLineTwo: 'If this is a mistake you can ',
      link: 'Post a New Job'
    },
    summary: {
      shiftSchedule: 'Shift Schedule',
      startDate: 'Start Date',
      endDate: 'End Date',
      longTerm: 'Long Term'
    }
  },
  headers: {
    newPost: 'New Posting',
    editPost: 'Edit Posting',
    newTemplate: 'New Template',
    editTemplate: 'Edit Template',
    newTryout: 'New Tryout Posting',
    editTryout: 'Edit Tryout',
    newTryoutTemplate: 'New Tryout Template',
    editTryoutTemplate: 'Edit Tryout Template',
    applyTemplateButton: 'Apply Template'
  },
  chooser: {
    heading: 'Posting Options',
    postFromTemplate: 'Post From Template',
    postFromScratch: 'Post New Job',
    postTryout: 'Post New Onsite Tryout',
    newJobHint: 'Create and post a new job',
    templateHint: 'Post a job from a saved template',
    newTryoutHint: 'Onboard Wonoloers and have them demonstrate skills for your workplace',
    postJobButton: 'Create',
    chooseTemplateButton: 'Edit & Repost',
    postTryoutButton: 'Create',
    noTemplates: 'No templates',
    templatesLabel: 'Choose Template',
    templatesPlaceholder: 'Select a template to use',
    initializing: 'Initializing the job form...',
    initFailed: 'Unable to initialize job form',
    loading: 'Loading templates...',
    templates: {
      heading: 'Templates',
      createNewButton: 'Create New Template'
    },
    templatesV2: {
      header: 'Template Library',
      content: 'Create and manage job templates',
      manageTemplates: 'Manage Templates'
    },
    drafts: 'Drafts (%draftCount%)',
    draftsHint: 'Continue editing drafts',
    draftsButton: 'View Drafts',
    importJobsFromCSV: 'Import Jobs from CSV',
    importJobsFromCSVMixed: 'Import 1099 Jobs from CSV',
    importJobsHint: 'Jobs will appear in Drafts after import',
    importJobsButton: 'View CSVs',
    postAJobSection: 'Post A Job',
    relatedOptionsSection: 'Related Options',
    manageShifts: {
      header: 'Create New Shift',
      content: 'Create a shift to schedule one or more jobs together at a venue',
      button: 'Create Shift',
    }
  },
  typeModal: {
    header: 'Select New Posting Classification',
    c1099Title: '1099',
    w2Title: 'W2',
    c1099Description: 'Wonoloers are treated as an independent contractor and compensation is not subject to taxes.',
    w2Description: 'Wonoloers are treated as an employee with benefits and compensation is subject to taxes.',
  },
  page: {
    heading: 'New Posting',
    post: 'Post Job',
    saveAsTemplateButton: 'Save As Template',
    templatePost: 'Post Job & Save as Template',
    postTryout: 'Post Tryout',
    templatePostTryout: 'Post Tryout & Save as Template',
    saving: 'Saving...',
    finish: 'Finish',
    cancel: 'Cancel',
    continue: 'Save & Continue',
    openSection: 'Enter Info',
    updateSection: 'Update Info',
    emptySection: 'No information entered',
    invalidSection: 'Updates needed',
    missingCategory: 'Please add a category to this position',
  },
  info: {
    heading: 'Job Basics',
    name: 'Job Name',
    contactName: 'Worksite Contact',
    contactPhone: 'Worksite Contact Phone',
    category: 'Position Category',
    owner: 'Job Owner',
    ownerHelperText: 'This should indicate the person responsible for managing this position through the job lifecycle',
    tempToHire: 'This position is temp to hire',
    assignBadgeLabel: 'Award Badge',
    jobCode: 'Job Code',
    jobSummary: 'Job Summary',
    additionalInformation: 'Job Additional Information',
    placeholder: {
      name: 'Insert a name...',
      contactName: 'Who Should the Wonoloers Contact',
      contactPhone: 'Area code and phone number',
      category: 'Choose Category',
      owner: 'Choose Job Owner',
      assignedBadge: 'Choose Badge',
      jobCode: 'Enter job code'
    }
  },
  fillAdvisor: {
    heading: 'Estimated Fill Rate'
  },
  dressCode: {
    heading: 'Clothing Requirements',
    attireRequirements: {
      presets: {
        subtitle: 'Choose from clothing presets or customize yourself',
      },
      label: {
        top: 'Top clothing',
        bottom: 'Bottom clothing',
        footwear: 'Footwear',
        equipment_to_bring: 'Equipment to bring',
        provided_at_venue: 'Clothing/equipment provided at venue',
        clothing_restriction: 'Clothing restrictions'
      },
      placeholder: {
        top: 'No preference',
        bottom: 'No preference',
        footwear: 'No preference',
        equipment_to_bring: 'Inform workers of any equipment they must bring on their own',
        provided_at_venue: 'Inform workers of any clothing or equipment you provide on-site',
        clothing_restriction: 'No preference'
      },
      emptyDescription: {
        top: 'No preference',
        bottom: 'No preference',
        footwear: 'No preference',
        clothing_restriction: 'None',
        equipment_to_bring: 'None',
        provided_at_venue: 'None'
      },
      heading: 'What clothing is required for this position?',
    },
    environments: {
      heading: 'What type of environment can workers expect? (select all that apply)',
      helperText: 'This helps inform the worker of any additional clothing or equipment considerations',
      emptyDescription: 'None apply',
      label: 'Environment expectations',
      errors: {
        conflicting: 'Environments are conflicting',
        hotAndCold: 'You cannot select both a hot and cold environment. They conflict with one another.'
      }
    },
    example: 'example'
  },
  location: {
    venueName: 'Location Name',
    address: 'Address',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    venueEditDescription: 'You can change this location address under Settings on the Locations page',
    travelTips: 'Travel Tips and Arrival Instructions',
    locationRadius: 'Location Radius',
    map: 'Check-In Radius',
    mapNote: 'Note: The map is based on the address you entered. Please click and drag the Geo-Fencing to refine and set your check-in area.',
    placeholder: {
      venue: 'Choose a location',
      venueName: 'Enter location name',
      address: 'Street address, suite, unit, building, floor, etc.',
      city: 'Enter city name',
      state: 'Choose a state',
      zip: 'Enter Zip',
      travelTips: 'Enter specific instructions...',
    },
    travelTipsHelperText: 'Provide clear instructions for Wonoloers on arrival, such as parking details, entry points, and who to meet, for a smooth start to their workday.',
    toolTips: {
      travelTips: {
        templates: 'Template Travel Tips, when empty, default to displaying the Travel Tips set on the venue. If you\'ve removed the tips from here but still need to update the default ones, they can be updated from the Locations page.'
      },
    },
  },
  where: {
    heading: 'Location',
    formErrors: {
      adminRequired: 'No venues exist. Please ask an Admin to create a new venue.',
      venue: 'Please enter a location name',
      address: 'Please enter an address',
      invalidAddress: 'The address you have entered is invalid, please enter a valid address. Please include building number, street address along with floor number, suite, or room number if appropriate.',
      city: 'Please enter a city name',
      invalidCity: 'The city you have entered is invalid, please enter a valid city name.',
      state: 'Please choose a state',
      travelTips: 'Please enter travel tips',
    }
  },
  pay: {
    heading: 'Pay',
    alert: 'Due to COVID-19, we are recommending you increase pay by 20%.',
    summary: {
      header: 'Payment Breakdown',
      label: {
        wonoloerPay: 'Total Wonoloer Pay',
        wonoloerPayPerDay: 'Wonoloer Pay (per day)',
        wonoloFee: 'Service Charge',
        totalFee: 'Total Cost',
        averageWonoloerPayPerDay: 'Wonoloer Pay (average per day)',
        averageWonoloFeePerDay: 'Service Charge (average per day)',
        averageDailyCost: 'Average Daily Cost'
      }
    },
    form: {
      label: {
        hourlyRate: 'Hourly Rate',
        flatDayRate: 'Flat Day Rate',
        bonusWage: 'I would like to add a bonus wage to this job if it goes unfilled by %date%',
        1099: '1099',
      },
      note: {
        new: 'Note: Please select a daily flat rate of pay or an hourly rate of pay.',
        edit: 'Note: You can’t change pay type after the job has been posted.'
      },
      tooltip: {
        bonusWage: 'You can use this feature to attract more Wonoloers to a job by adding a flat bonus.',
      },
    }
  },
  schedule: {
    heading: 'Time & Wonoloers',
    noBackgroundChecks: {
      description: 'I do not require background checks for Wonoloers accepting this job',
      label: 'Optional Background Check'
    },
    slots: 'Number of Wonoloers Requested Per Shift',
    slotsShort: 'Number of Wonoloers',
    startTime: 'Start Time',
    paidDuration: 'Estimated Paid Time',
    breakDuration: 'Estimated Unpaid Time',
    totalDuration: 'Total Calculated Time',
    startDate: 'Job Start Date',
    repeatOn: 'Repeat On',
    preferredHeading: 'Preferred Team (optional)',
    preferredSummaryTitle: 'Current Team Members Selected',
    preferredHint: 'You may add teams that you have worked with before',
    preferredSummarySingle: 'You have selected 1 member from your Preferred Team for this job',
    preferredSummary: 'You have selected <b>%count%</b> members from your Preferred Team for this job',
    lowerPool: {
      description: 'I would like to open my invitation up to a broader pool of wonoloers, including those with high no call no show rates',
      label: 'Broader Pool'
    },
    hours: 'Hours',
    minutes: 'Minutes',
    totalDurationPrefix: 'Total paid and unpaid time is',
    paidTooltip: 'This is where you enter the total hours and minutes of paid time the Wonoloer will work',
    unpaidTooltip: 'This is where you enter the total hours and minutes of unpaid time the Wonoloer will take',
    plusOccurrences: '+%additional% more occurrences in series',
    repeat: {
      deleteAll: 'Delete All',
      restoreAll: 'Restore All',
      deleteRow: 'Delete',
      restoreRow: 'Restore',
      repeatsEveryHeading: 'Repeats',
      endsHeading: 'Ends',
      doesNotRepeat: 'Does not repeat',
      repeatsEvery: 'Repeats every',
      daily: 'Daily',
      weekly: 'Weekly On',
      noRepeat: 'Does not repeat',
      never: 'Never',
      on: 'On',
      datePlaceholder: 'end date',
      after: 'After',
      weeks: 'Weeks',
      occurrences: 'Occurrences',
      occurrencesNote: 'Note: You may only schedule up to %max% occurrences for each job',
      sameWonoloers: 'I would like the same wonoloers every shift',
      sameTooltip: "While we can't guarantee you will get the same Wonoloer, this option will help you to attract Wonoloers who prefer longer term engagements",
    },
    edit: {
      note: 'You may edit each day individually',
      tooMany: 'Please enter a number no more than %n%',
      incomplete: 'Unable to edit an incomplete schedule',
    },
    breakdown: 'Schedule Breakdown',
    repeatDescription: 'You can use this feature to quickly and easily set this job to repeat',
    preferredTooltip: 'You can use this feature to invite specific groups of Wonoloers to see and accept this job first.',
    day: 'Day',
    paidTime: 'Paid Time',
    unpaidTime: 'Unpaid Time',
    placeholder: {
      startTime: 'Choose a time',
    }
  },
  time: {
    heading: 'Time',
    recurringShift: {
      title: 'Recurring',
      description: 'Follows a shift schedule within a date range',
    },
    flexibleShift: {
      title: 'One off',
      description: 'Does not use a shift schedule, can occur on one or multiple days',
    },
  },
  wonoloers: {
    heading: 'Wonoloers',
    table: {
      shift: 'Number of wonoloers per shift',
      preferred: 'Preferred team members (optional)',
      broaderPool: 'Broader pool',
      backgroundCheck: 'Background check'
    },
  },
  repeatOptions: {
    editRepeat: 'Edit Repeating Occurrences',
    editSchedule: 'Edit Schedule',
    saveSchedule: 'Save Schedule',
    editScheduleNote: 'Note: You may edit each day individually',
    editRepeatNote: 'Note: Once you set the schedule, you may edit each day individually',
    createRepeat: 'Set Up Repeating Occurrences',
    editDays: 'Edit Individual Days',
    backToSchedule: 'Back to Schedule'
  },
  preferred: {
    addTeam: 'Add Preferred Team Members',
    editTeam: 'Edit Preferred Team Members',
    confirmTeam: 'Confirm Team',
    belowMinimumConfirmTeam: 'Select at least %minimum% %wonoloers%',
    belowMinimumAlert: 'Select at least %minimum% %wonoloers%. To maximize fill rate, add %idealPreferredWonoloerCount% members to your Closed Preferred team.',
    belowIdealAlert: 'To maximize fill rate, add %idealPreferredWonoloerCount% members to your Closed Preferred team.',
    atIdealAlert: 'You have selected a number of Wonoloers that will maximize the fill rate of this job posting.',
    removeWonoloersHeader: 'Preferred Team',
    notAvailable: 'Preferred Wonoloer selection is not available',
    checkboxLabel: 'closed-preferred',
  },
  badges: {
    modalTitle: 'Badges',
    fields: {
      badgeName: 'Badge Name',
      badgeDescription: 'Badge Description',
      badgeDescriptionPlaceHolder: 'A very short description of what this badge is and what it is used for'
    },
    alert: {
      title: 'W2 Badge Required',
      body: 'A W2 badge is required to post this job to ensure every Wonoloer conforms with W2 regulations and your company guidelines. A specific W2 badge will automatically apply based on job details.',
    },
    saveNewBadge: 'Save Badge',
    newBadgeModalHeader: 'Badge Creation',
    newBadge: 'Create New Badge',
    heading: 'Badges',
    note: 'Select up to %limit% badges',
    limitNote: 'Note: You may add up to %limit% badges in total',
    save: 'Save Badges',
    none: 'No badges available',
    add: 'Add Badges',
    edit: 'Edit Badges',
    tooltip: 'Badges are used to help find Wonoloers with highly specific skills or certifications that are critical to success for your task.',
    assignedHint: 'Note: Select or create the badge that will be auto-awarded to Wonoloers after they complete all sessions for this tryout',
    createHint: 'Note: Once a badge has been created only Wonolo can edit or delete it',
    noneRequired: 'None required'
  },
  requirements: {
    heading: 'Job Requirements',
    summary: 'Summary',
    task: 'Task',
    taskHeading: 'What will the worker be doing in this position?',
    taskHelperText: 'Clearly describe the key tasks and main responsibilities of the job to help Wonoloers understand what they\'ll be doing.',
    placeholder: {
      task: 'Enter your tasks...',
    },
    skills: {
      heading: 'Are there any specific skills required for this position?',
      shortHeading: 'Skills & Requirements',
      helperText: 'Summarize the key skills Wonoloers need for the job, including any physical demands, necessary certifications, or previous experience.',
      skills: 'Skills',
      placeholder: 'Enter a new skill here',
      new: 'New Skill',
      addNew: 'Add New',
      add: 'Add Skills & Requirements',
      edit: 'Edit Skills & Requirements',
      clear: 'Clear Selected',
      save: 'Save Selected',
      headingTooltip: 'Please enter a simple term to search tags. Ex: Warehouse workers may need to lift things. Enter in the word "lift" to see requirements that match.',
      preFill: 'Click on the skills or requirements you wish to select. You may add no more than %selectLimit%.',
      error: {
        maxNumber: 'Max # of requirements reached',
        duplicateRequirement: 'Requirement already exists'
      }
    }
  },
  alerts: {
    update: {
      success: 'Your change was made successfully.',
      error: 'There was a problem submitting your change. Our team has been notified.',
      pending: 'Your request is processing. You\'ll be emailed in a few minutes when it\'s complete ',
      singleSuccess: '%job% was successfully updated.',
      bulkSuccess: '%count% job postings were successfully updated.',
      w2BadgeChange: 'The W2 badge in General Information was updated based on your job location.',
    }
  },
  editTemplateConfirmationModal: {
    title: 'Confirm Template Changes',
    criticalChange: {
      body: 'Wonolo has detected critical changes to this template. \n Changes will not be applied to any active job requests using the current template.',
      radioButtonHeader: 'Are you sure you want to update this template or create a new one?'
    },
    inputs: {
      updateExisting: 'Update Existing Template',
      createNew: 'Create New Template'
    },
    nonCriticalChangeBody: 'Updates will not be applied to any active job requests using current template'
  },
  applytemplateModal: {
    header: 'Select Template',
    placeholder: 'Select Template'
  },
  bulkEditOptionModal: {
    title: 'Update Job',
    inputs: {
      thisJobOnly: 'Apply to this job only',
      bulkEdit: 'Apply to this job and %count% upcoming jobs with the same general information and location'
    },
    collapse: {
      closed: 'View job postings',
      open: 'Hide job postings'
    }
  },
};
